import { IconProps } from "../../utils/global-types/global-types";

const GalleryIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_4208_66680)">
        <mask
          id="mask0_4208_66680"
          width="16"
          height="16"
          x="1"
          y="1"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
        >
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </mask>
        <g fill="currentColor" mask="url(#mask0_4208_66680)">
          <path d="M5 6.667a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0"></path>
          <path
            fillRule="evenodd"
            d="M1.834 5.333A2.833 2.833 0 0 1 4.667 2.5h8.667a2.833 2.833 0 0 1 2.833 2.833v7.334a2.833 2.833 0 0 1-2.834 2.833H4.668a2.833 2.833 0 0 1-2.833-2.833zM4.667 3.5c-1.013 0-1.833.82-1.833 1.833v6.46l1.772-1.773a1.5 1.5 0 0 1 2.121 0L8 11.293l3.273-3.273a1.5 1.5 0 0 1 2.121 0l1.773 1.773v-4.46c0-1.012-.821-1.833-1.833-1.833z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4208_66680">
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default GalleryIcon;
